import { IconName } from "@blueprintjs/core";
import { Registry } from "react-registry";
import { Dispatch } from "redux";

import initialState from "core/reducers/initialState";
import Logger from "core/util/Logger";
import { IMenuNode } from "./MenuTree.view";

/**
 * Utility for registering and retrieving link types for use in static menus.
 *
 * @author chills
 */

// tslint:disable:max-classes-per-file

interface ILinkProps {
	id: string;
	children?: IMenuNode[];
	isExpanded?: boolean;
}

/**
 * Registered link type definition.
 * Example: {@link ./StaticLink.tsx} {@link ./PageLink.tsx}
 */
export interface ILinkType<T = {}> {
	// registered by type
	type: string;

	// display name for configuration menus
	label: string;

	// display icon (optional) for configuration menus
	icon?: IconName;

	// render the config form
	renderInput?: (value: T, onChange: (value: T) => void) => JSX.Element;

	canAddChildren?: boolean;

	/**
	 * map data to menu node.
	 * @param data - the link config.
	 * @param props - contextual data (id, children, etc).
	 * @param state - the redux store's current state, for retrieving things like current route location, etc.
	 */
	mapDataToMenuNode: (data: T, props: ILinkProps, state: any) => IMenuNode<T>;

	// click handler for link type. receives dispatch prop to trigger navigation, etc.
	doNavigate?: (data: T, dispatch: Dispatch<typeof initialState>, id: string) => void;
}

export class LinkTypeRegistry {

	public static registerType<T = {}>(navLink: ILinkType<T>): ILinkType<T> {
		Registry.register(navLink, {id: navLink.type, registry: "__core:linktype"});
		return navLink;
	}

	public static getType<T = {}>(type: string): ILinkType<T> {
		return Registry.get({id: type, registry: "__core:linktype"}) as ILinkType<T>;
	}

	public static getTypes(types: string[]): ILinkType[] {
		const res = [];

		for (const type of types) {
			const linkType = this.getType(type);
			if (linkType) {
				res.push(linkType);
			} else {
				Logger.error("INVALID LINK TYPE: %s", type);
			}
		}

		return res;
	}
}

export interface IStaticLinkData {
	label: string;
	icon: any;
	iconType: "bp" | "external";
}



// WEBPACK FOOTER //
// ./src/common/views/menuTree/ILinkType.ts